import { useUrlGenerator } from '@folklore/routes';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from './Button';

import styles from '../../../styles/buttons/profile.module.scss';

const propTypes = {
    user: PropTypes.shape({}),
    className: PropTypes.string,
};

const defaultProps = {
    user: null,
    className: null,
};

function ProfileButton({ user, className }) {
    const route = useUrlGenerator();
    const { name = null, firstName = null, lastName = null } = user || {};

    const finalName = useMemo(
        () =>
            firstName !== null
                ? `${firstName}${
                      lastName !== null && lastName.length > 0 ? ` ${lastName[0]}.` : ''
                  }`
                : name,
        [firstName, lastName, name],
    );

    return (
        <Button
            href={`${route('profile')}?next=${route('leaderboard')}`}
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <span className={styles.name}>
                <FormattedMessage defaultMessage="Name" description="Row label" />
            </span>
            <span className={styles.value}>{finalName}</span>
            <span className={styles.icon}>
                <FontAwesomeIcon icon={faPencil} />
            </span>
        </Button>
    );
}

ProfileButton.propTypes = propTypes;
ProfileButton.defaultProps = defaultProps;

export default ProfileButton;
